"use strict";

import * as THREE from "three";

import frag from './Shaders/Shoot.frag';
import vert from './Shaders/Shoot.vert';

class ShootMaterial extends THREE.ShaderMaterial {

    static TextureAtlas: THREE.Texture = new THREE.TextureLoader().load(
        (new URL("../assets/textures/atlas.png", import.meta.url)).toString(),
        (texture) => {
        });


    uniforms: ShootMaterialUniforms;

    constructor(preset?: ShootMaterialPreset) {
        super();

        this.vertexShader = vert;
        this.fragmentShader = frag;

        let shootTextureIndex = preset?.shootTextureIndex || 0;
        let x = shootTextureIndex % 8.;
        let y = Math.floor(shootTextureIndex / 8.);
        let width = 1. / 8.;
        let height = 1. / 4.;
        let uvTransform = new THREE.Vector4(x * width, y * height, width, height);

        this.uniforms =
        {
            time: { value: 0 },
            progress: { value: 1.0 },
            lightPosition: { value: new THREE.Vector3(0, 2, 1) },

            shootTexture: { value: ShootMaterial.TextureAtlas },
            shootUVTransform: { value: uvTransform },

            shootTextureColorA: { value: new THREE.Color(.5, .5, .5) },
            shootTextureColorB: { value: new THREE.Color(1, 1, 1) },

            shootTextureTint: { value: new THREE.Color(1, 1, 1) },
            shootTextureAlpha: { value: 1 },

            ...preset?.uniforms
        }

        this.side = THREE.DoubleSide
    }
}

export default ShootMaterial;